import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initPixels, pixelTrack } from "@/lib/pixels";

/**
 * Global pixel tracker — fires Meta Pixel + Google Ads PageView on every
 * public-route SPA navigation. Env-gated inside `initPixels` /
 * `pixelTrack` so no-op if REACT_APP_META_PIXEL_ID / REACT_APP_GOOGLE_ADS_ID
 * are unset (dev / preview).
 *
 * Excluded surfaces (crawler-noindex or authed): /candidate, /dashboard,
 * /admin, /superadmin, /login, /signup — we don't want to track authed
 * users' internal navigation as ad conversions.
 */

const EXCLUDED_PREFIXES = [
    "/candidate", "/dashboard", "/admin", "/superadmin",
    "/login", "/signup", "/hire",
];

function isPublicPath(p) {
    return !EXCLUDED_PREFIXES.some((pref) => p.startsWith(pref));
}

export default function GlobalPixelTracker() {
    const { pathname } = useLocation();

    // Init once — idempotent inside initPixels().
    useEffect(() => { initPixels(); }, []);

    // Fire PageView on public-route change.
    useEffect(() => {
        if (!isPublicPath(pathname)) return;
        try { pixelTrack("landing_view", { path: pathname }); } catch (_) { /* silent */ }
    }, [pathname]);

    return null;
}
